import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from "chart.js";
import { Radar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const options = {
  plugins: {
    tooltip: {
    },

    datalabels: {
      display: false,
    },
  },

  scales: {
    r: {
      ticks: {
        display: false,
        backdropColor: 'rgba(0, 0, 0, 0)', // transparent background
      },
      angleLines: {
        color: "#696969",
      },
      suggestedMin: 0,
      suggestedMax: 1,
      grid: {
        color: "#959595",
        circular: true,
      },
      pointLabels: {
        color: "#bcbcbc",
        // reduce font size to fit labels
        font: function (context) {
          var avgSize = Math.round(
            (100 + context.chart.height + context.chart.width) / 2
          );
          var size = Math.round(avgSize / 80);
          return {
            size: size > 8 ? size : 8,
          };
        },
      },
    },
  },
};

const optionsNoData = {
  scales: {
    r: {
      angleLines: {
        color: "#363636",
      },
      grid: {
        color: "#363636",
        circular: true,
      },
      pointLabels: {
        color: "#363636",
      },
      ticks: {
        color: "#363636",
        backdropColor: 'rgba(0, 0, 0, 0)', // transparent background
      },
    },
  },
};

const noData = {
  labels: [null, null, null],
  datasets: [
    {
      label: "Waiting for data...",
      data: [null, null, null],
      backgroundColor: "#00000000",
      borderColor: "#00000000",
      borderWidth: 1,
    },
  ],
};

export default function RadarChart() {
  ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
  );

  const cityIOdata = useSelector((state) => state.cityIOdataState.cityIOdata);
  const [radarData, setRadarData] = useState();

  const createRadarData = (indicators) => {
    let radarData = {
      labels: [],
      datasets: [],
    };

    for (let i = 0; i < indicators.length; i++) {
      if (indicators[i].viz_type === "new_radar") {
        radarData.labels.push(...indicators[i].value.labels);
        radarData.datasets.push(...indicators[i].value.datasets);
      }
    }

    return radarData;
  };

  useEffect(() => {
    if (!cityIOdata.indicators) {
      setRadarData(noData);
    } else {
      const d = createRadarData(cityIOdata.indicators);
      setRadarData(d);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityIOdata]);

  return (
    <div style={{position:'relative',width:'100%',height:'100%',color:'black'}}>

      {radarData && (
          <Radar
          data={radarData}
          options={cityIOdata.indicators ? options : optionsNoData}
        />


      )}
      Radar
    </div>
  );
}
